import { render } from "./XCerrar.vue?vue&type=template&id=3abd4616&scoped=true"
import script from "./XCerrar.vue?vue&type=script&lang=js"
export * from "./XCerrar.vue?vue&type=script&lang=js"

import "./XCerrar.vue?vue&type=style&index=0&id=3abd4616&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3abd4616"

export default script